import { Routes } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CookiesComponent } from './cookies/cookies.component';
import { Paths, SemiPath } from '../../../config/config';
import { SearchComponent } from './search/search.component';
import { NotFoundComponent } from './not-found/not-found.component';
const ɵ0 = {
    page: Paths.Homepage
}, ɵ1 = {
    page: Paths.Privacy
}, ɵ2 = {
    page: Paths.Cookies
}, ɵ3 = {
    page: Paths.Cookies
};
const routes = [
    {
        path: '',
        component: HomepageComponent,
        data: ɵ0
    },
    {
        path: SemiPath.Privacy,
        component: PrivacyComponent,
        data: ɵ1
    },
    {
        path: SemiPath.Cookies,
        component: CookiesComponent,
        data: ɵ2
    },
    {
        path: `${SemiPath.Search}/:term`,
        component: SearchComponent
    },
    {
        path: SemiPath.NotFound,
        component: NotFoundComponent,
        data: ɵ3
    }
];
export class RootRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
